<template>
  <el-main class="statisticsBox">
    <el-row class="selectBox">
      <el-form
        size="medium"
        :inline="true"
        :model="queryForm"
        ref="queryForm"
        :rules="rules"
        @submit.native.prevent
      >
        <div class="query-box">
          <el-form-item class="r-20" prop="year" v-if="isActive === 'year'">
            <el-date-picker
              class="selectMonth"
              v-model="queryForm.year"
              value-format="yyyy"
              :picker-options="pickerOptions"
              type="year"
              :placeholder="year"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="r-20" prop="month" v-if="isActive === 'month'">
            <el-date-picker
              class="selectMonth"
              v-model="queryForm.month"
              value-format="yyyy-MM"
              :picker-options="pickerOptions"
              type="month"
              :placeholder="month"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="r-20" prop="day" v-if="isActive === 'day'">
            <el-date-picker
              class="selectMonth"
              v-model="queryForm.day"
              :picker-options="pickerOptions"
              clear-icon="el-icon-circle-close"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="day"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            class="selectMonth time"
            v-if="isActive === 'choiceTime'"
          >
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="queryForm.startTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="开始时间"
                :picker-options="pickerOptionsStart"
              >
              </el-date-picker>
            </el-form-item>
            <span class="line-row">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="queryForm.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="截止时间"
                :picker-options="pickerOptionsEnd"
              >
              </el-date-picker>
            </el-form-item>
          </el-form-item>

          <el-form-item class="r-20" prop="plateNum">
            <el-input
              placeholder="车牌号"
              @keyup.enter.native="query"
              v-model.trim="queryForm.plateNum"
            ></el-input>
          </el-form-item>
          <el-form-item class="r-20" prop="name">
            <el-input
              placeholder="车辆绑定人"
              @keyup.enter.native="query"
              v-model.trim="queryForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item class="r-20" prop="deptIds">
            <el-cascader
              ref="cascader_ref"
              v-model="queryForm.deptIds"
              :options="deptList"
              :props="optionProps"
              clearable
              collapse-tags
              placeholder="-选择公司部门-"
              :disabled="onlyReadDept"
            ></el-cascader>
          </el-form-item>
          <el-form-item class="r-20" prop="areaIds">
            <el-cascader
              v-model="queryForm.areaIds"
              :options="areaList"
              :props="optionProps"
              clearable
              collapse-tags
              placeholder="-选择区域-"
              :disabled="onlyReadArea"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query">查询</el-button>
            <el-button @click="reset">取消</el-button>
          </el-form-item>
        </div>
        <div style="margin-bottom: 20px">
          <el-button type="primary" style="width: 100px" @click="exportData"
            >导出Excel</el-button
          >
          <el-button type="primary" style="width: 100px" @click="selectCheckbox"
            >数据列选择</el-button
          >
        </div>
      </el-form>
    </el-row>
    <el-row class="tableBox" v-if="checkedColTitle.length > 0">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        size="mini"
        style="width: 100%"
        height="560"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        @sort-change="tableSort"
        :key="key"
      >
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          v-for="col in checkedColTitle"
          :label="col.label"
          :key="col.id"
          :prop="col.prop"
          :min-width="changeWidth(col.id)"
          show-overflow-tooltip
          :sortable="col.sort == 1 ? 'custom' : null"
        >
          <template slot="header">
            <span style="margin-right: 2px">{{ col.label }}</span>
            <span
              class="iconfont"
              :class="[
                col.prop === sort_icon
                  ? 'icon-paixushengxu'
                  : 'icon-paixujiangxu',
                { paixuBlue: col.prop === active },
              ]"
              v-if="col.sort == 1"
            ></span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="noTableData" v-else>暂无数据</el-row>
    <!-- 数据项选择 -->
    <el-dialog title="数据列选择" :visible.sync="choiceVisible">
      <div class="dialogCon">
        <!-- <el-button type="primary" class="dialog-title" @click="defaultChoice"
          >恢复默认选择</el-button
        > -->
        <div class="checkBoxs">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="checkAllChange"
            >全选</el-checkbox
          >
          <el-checkbox-group
            v-model="checkedCol"
            @change="handleCheckedLabelChange"
          >
            <el-checkbox
              v-for="item in titleList"
              :label="item.label"
              :key="item.prop"
              :disabled="
                item.prop === 'id' ||
                  item.prop === 'plateNum' ||
                  item.prop === 'name' ||
                  item.prop === 'deptName' ||
                  item.prop === 'area' ||
                  item.prop === 'vinBindTime' ||
                  item.prop === 'contractTime' ||
                  item.prop === 'startTime' ||
                  item.prop === 'endTime'
              "
              class="checkboxRow"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="choiceColumn">确 定</el-button>
        <el-button @click="choiceVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
export default {
  name: "Statistics",
  data() {
    return {
      queryForm: {
        year: "",
        month: "",
        day: "",
        time: "",
        startTime: "",
        endTime: "",
        plateNum: "",
        name: "",
        deptIds: [],
        areaIds: [],
      },
      active: "",
      key: 0,
      sort_icon: "",
      loading: false,
      onlyReadDept: false,
      onlyReadArea: false,
      year: "--选择年份--",
      month: "选择月份",
      day: "选择日期",
      checkAll: false,
      isIndeterminate: true,
      choiceVisible: false, // 数据项选择模态框显示与隐藏
      deptVisible: false,
      // 将来、未到的日期禁止选中
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptionsStart: this.expireTimeOptionStart(),
      pickerOptionsEnd: this.expireTimeOptionEnd(),
      tableData: [],
      titleList: [],
      defaultChoiceFlag: false,
      checkedCol: [
        "序号",
        "车牌号",
        "车辆绑定人",
        "公司部门",
        "所属区域",
        "日期",
        "月份",
        "年份",
        "车辆绑定日期",
        "截止日期",
        "开始时间",
        "截止时间",
      ], // 默认选中的表头数据
      checkedColTitle: [],
      deptList: [], //公司部门
      areaList: [], //区域列表
      yearList: [],
      rules: {
        // year: [
        // 	{
        // 		required: true,
        // 		trigger: "change",
        // 		message: "请选择年份",
        // 	},
        // ],
        // month: [
        // 	{
        // 		required: true,
        // 		trigger: "change",
        // 		message: "请选择月份",
        // 	},
        // ],
        // day: [
        // 	{
        // 		required: true,
        // 		trigger: "change",
        // 		message: "请选择日期",
        // 	},
        // ],
        startTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择开始时间",
          },
        ],
        endTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择截止时间",
          },
        ],
      },
      optionProps: {
        value: "id",
        multiple: true,
        emitPath: true,
      },
    };
  },
  computed: {
    changeWidth: function() {
      return function(index) {
        if (index == 0 || index == 1) {
          return 90;
        } else {
          return 160;
        }
      };
    },
    changeChoice: function() {
      const { deptIds, areaIds } = this.queryForm;
      return { deptIds, areaIds };
    },
  },
  props: ["isActive"],
  watch: {
    isActive: {
      handler: function(val) {
        this.handleTabData(val);
      },
      immediate: true,
      deep: true,
    },
    changeChoice: {
      handler: function(val) {
        let deptChange = val.deptIds.length;
        let areaChange = val.areaIds.length;
        if (deptChange > 0) {
          this.onlyReadArea = true;
        } else {
          this.onlyReadArea = false;
        }
        if (areaChange > 0) {
          this.onlyReadDept = true;
        } else {
          this.onlyReadDept = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.queryForm.year = new Date().getFullYear() + "";
    // 处理获取当前月份小于两位数补0问题
    let month =
      new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1;
    this.queryForm.month = new Date().getFullYear() + "-" + month;
    this.queryForm.day = this.$nowDate().split(" ")[0];
    this.getDeptList();
    this.getAreaList();
  },
  methods: {
    // 开始时间和结束时间限制函数
    expireTimeOptionStart() {
      // 当结束时间不为空时，开始时间早于结束时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.endTime) {
            return time.getTime() > new Date(this.queryForm.endTime).getTime();
          } else {
            return time.getTime() > Date.now(); //结束时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    expireTimeOptionEnd() {
      // 当开始时间不为空时，结束时间要晚于开始时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.startTime) {
            return (
              time.getTime() <=
                new Date(this.queryForm.startTime).getTime() - 8.64e7 ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },

    // 表格排序
    tableSort({ column, prop, order }) {
      console.log(column);
      if (order === "ascending") {
        // 升序
        this.sort_icon = prop;
        this.active = prop;
        this.tableData.sort((a, b) => {
          if (a[prop] < b[prop]) {
            return -1;
          } else if (a[prop] > b[prop]) {
            return 1;
          } else {
            return 0;
          }
        });
      }
      if (order === "descending") {
        // 降序 图标颜色为选中状态
        this.sort_icon = "";
        this.active = prop;
        this.tableData.sort((a, b) => {
          if (a[prop] < b[prop]) {
            return 1;
          } else if (a[prop] > b[prop]) {
            return -1;
          } else {
            return 0;
          }
        });
      }
      if (order === null) {
        // 降序 图标颜色为选中状态
        this.sort_icon = "";
        this.active = "";
        this.key += 1;
        this.handleTabData(this.isActive);
      }
    },
    checkAllChange(val) {
      // val 控制全选按钮的值
      let labelArr = [];
      this.titleList.map((item) => {
        labelArr.push(item.label);
      });
      // 选中状态，如果全选按钮的值是true，则选中的数组由当前默认选中的五个变成所有
      this.checkedCol = val
        ? labelArr
        : [
            "序号",
            "车牌号",
            "车辆绑定人",
            "公司部门",
            "所属区域",
            "日期",
            "月份",
            "年份",
            "车辆绑定日期",
            "截止日期",
            "开始时间",
            "截止时间",
          ];
      this.isIndeterminate =
        this.checkedCol.join() == labelArr.join() ? false : true;
    },
    // 点击每一个复选框触发的回调
    handleCheckedLabelChange(val) {
      // val 得到当前选中的值
      // console.log(val.length);
      let checkedCount = val.length;
      // 如果选中值的数量等于所有列的数量，全选状态
      this.checkAll = checkedCount === this.titleList.length;
      // 非全选样式  选中数量的值大于等于默认选中的数量并且小于所有选中状态的数量
      this.isIndeterminate =
        checkedCount >= 5 && checkedCount < this.titleList.length;
    },
    // 点击数据列选择按钮触发
    selectCheckbox() {
      // 打开模态框
      this.choiceVisible = true;
      // 默认全选状态
      this.$nextTick(() => {
        if (this.checkedCol.length == this.titleList.length) {
          this.isIndeterminate = false;
          this.checkAll = true;
        } else {
          this.isIndeterminate = true;
          this.checkAll = false;
        }
      });
      this.checkedCol = this.checkedColTitle.map((item) => item.label);
    },
    // 确定选择显示的数据列回调
    choiceColumn() {
      this.choiceVisible = false;
      let tempArr = [];
      this.titleList.forEach((title, index) => {
        // 得到表格列数据顺序和值，找出选中数据项数据，根据顺序添加到 tempArr 中，更新表格列数据
        this.checkedCol.filter((col) => {
          if (col == title.label) {
            tempArr.splice(index, 0, title);
          }
        });
      });
      this.checkedColTitle = tempArr;
    },
    reset() {
      this.$resetForm(this, "queryForm");
      console.log(this.queryForm);
      this.handleTabData(this.isActive);
    },
    query() {
      console.log(this.isActive, this.queryForm);
      this.$refs.queryForm.validate(async (valid) => {
        if (valid) {
          this.handleTabData(this.isActive);
        }
      });
    },
    exportData() {
      console.log("exportData", this.queryForm);
      let type = this.isActive;
      let httpString = "";
      if (type == "day" || type == "month" || type == "year") {
        httpString = "/api/dynamo/data/statistics/export";
      }
      if (type == "sum") {
        httpString = "/api/dynamo/data/statistics/exportAll";
      }
      if (type == "choiceTime") {
        httpString = "/api/dynamo/data/statistics/exportAssign";
      }
      let url = "";
      this.$confirm("确定导出当前查询条件下的数据吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
      }).then(async () => {
        url =
          httpString +
          "?time=" +
          this.queryForm.time +
          "&startTime=" +
          this.queryForm.startTime +
          "&endTime=" +
          this.queryForm.endTime +
          "&plateNum=" +
          this.queryForm.plateNum +
          "&name=" +
          this.queryForm.name +
          "&deptIds=" +
          this.queryForm.deptIds +
          "&areaIds=" +
          this.queryForm.areaIds;
        window.location.href = url;
      });
    },
    async getDeptList() {
      let { data: res } = await this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        let data = this.handleTreeData(res.data);
        this.deptList = data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getAreaList() {
      let { data: res } = await this.$axios.get("/api/sys/area/list");
      if (res.code == 1) {
        // 处理最后一级children为空时不显示无数据空白节点页面
        let data = this.handleTreeData(res.data);
        this.areaList = data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleTreeData(data) {
      data.forEach((item) => {
        if (item.children.length == 0) {
          item.children = undefined;
        } else {
          this.handleTreeData(item.children);
        }
      });
      return data;
    },
    // 处理不同tab下的不同数据
    handleTabData(type) {
      this.$nextTick(() => {
        if (type == "day") {
          this.getTitleList(0);
          this.queryForm.time = this.queryForm.day;
        } else if (type == "month") {
          this.getTitleList(1);
          console.log(this.queryForm.month);
          this.queryForm.time = this.queryForm.month;
        } else if (type == "year") {
          this.getTitleList(2);
          this.queryForm.time = this.queryForm.year;
        } else if (type == "sum") {
          this.getTitleList(3);
        } else if (type == "choiceTime") {
          this.queryForm.time = "";
          this.getTitleList(4);
        }
        this.getTableData(type);
      });
    },
    // 处理数组数据，没40个数组为一组数据
    chunk(arr, size) {
      var result = [];
      for (var i = 0, len = arr.length; i < len; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },

    async getTableData(type) {
      let obj = {};
      obj.startTime = this.queryForm.startTime;
      obj.endTime = this.queryForm.endTime;
      obj.plateNum = this.queryForm.plateNum;
      obj.name = this.queryForm.name;
      obj.deptIds = this.queryForm.deptIds.join(",");
      this.tableData = [];
      this.loading = true;
      if (this.queryForm.areaIds.length > 200) {
        let data = this.chunk(this.queryForm.areaIds, 200);
        let tempData;
        let tempList = [];
        for (let i = 0; i < data.length; i++) {
          obj.areaIds = data[i].join(",");
          if (type == "day" || type == "month" || type == "year") {
            obj.time = this.queryForm.time;
            let { data: res } = await this.$axios.get(
              "/api/dynamo/data/statistics/list",
              {
                params: obj,
              }
            );
            tempData = res;
          }
          if (type == "sum") {
            let { data: res } = await this.$axios.get(
              "/api/dynamo/data/statistics/listAll",
              {
                params: obj,
              }
            );
            tempData = res;
          }
          if (type == "choiceTime") {
            let {
              data: res,
            } = await this.$axios.get(
              "/api/dynamo/data/statistics/listAssign",
              { params: obj }
            );
            tempData = res;
          }
          if (tempData.code == 1) {
            if (tempData.data.length > 0) {
              tempList.push(...tempData.data);
            }
            this.tableData = tempList;
          }
        }
      } else {
        obj.areaIds = this.queryForm.areaIds.join(",");
        let tempData;
        if (type == "day" || type == "month" || type == "year") {
          obj.time = this.queryForm.time;
          let { data: res } = await this.$axios.get(
            "/api/dynamo/data/statistics/list",
            {
              params: obj,
            }
          );
          tempData = res;
        }
        if (type == "sum") {
          console.log(obj);
          let { data: res } = await this.$axios.get(
            "/api/dynamo/data/statistics/listAll",
            {
              params: obj,
            }
          );
          tempData = res;
        }
        if (type == "choiceTime") {
          let { data: res } = await this.$axios.get(
            "/api/dynamo/data/statistics/listAssign",
            {
              params: obj,
            }
          );
          tempData = res;
        }
        if (tempData.code == 1) {
          this.tableData = tempData.data;
          this.tempTableData = tempData.data.slice();
        } else {
          this.$message.warning(tempData.msg);
        }
      }

      // 拿到数据关闭等待
      this.loading = false;
    },
    async getTitleList(type) {
      let obj = {};
      obj.type = type;
      let { data: res } = await this.$axios.get(
        "/api/dynamo/data/statistics/title",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.titleList = res.data;
        // 页面打开按钮默认全选
        this.checkedColTitle = [...this.titleList];
        this.checkedCol = this.checkedColTitle.map((item) => item.label);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
  width: 100px;
  margin-bottom: 10px;
}
.selectMonth {
  ::v-deep .el-input__inner {
    padding-left: 15px;
  }
}
.noTableData {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 560px;
  color: #909399;
  letter-spacing: 15px;
}
// 分页器样式改变
// .tableBox /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
//   background-color: #fff !important;
//   color: #0093ff;
//   border: 1px solid #0093ff;
// }
// ::v-deep .el-pagination.is-background .el-pager li{
//   background: #fff;
//   border: 1px solid #ccc;
//   border-radius: 4px;
// }
::v-deep .el-icon-time:before {
  content: "\e78e";
}
::v-deep .el-form-item__content .el-input__inner {
  height: 36px !important;
  line-height: 36px;
}
.time {
  ::v-deep .el-form-item {
    margin-bottom: 0 !important;
  }
}
::v-deep .el-cascader__tags .el-tag {
  max-width: 62%;
}
::v-deep .el-table__body-wrapper {
  height: 480px !important;
}

::v-deep .el-date-editor {
  .el-input__suffix {
    position: absolute;
    height: 40px;
    left: 270px;
    top: 0px;
    .el-input__icon.el-icon-circle-close {
      transition: none;
      width: 26px;
      position: relative;
      font-size: 16px;
      &:before {
        background-color: #fff; //这一条必须写，覆盖原先的日期icon
      }
    }
  }
}
/*下拉选择框-多选-内容过长-用...代替    begin    */
// ::v-deep .el-tag.el-tag--info {
//   background-color: #f4f4f5;
//   border-color: #e9e9eb;
//   color: #909399;
//   max-width: calc(100% - 50px);
//   /* white-space: nowrap;
//      text-overflow: ellipsis;
//      overflow: hidden;*/
// }
/** 下拉选择框-多选-内容过长隐藏选择数量显示 */
// ::v-deep .el-tag.el-tag--info:nth-child(2) {
//   // width: calc(100% - 50px);
//   // display: none;
// }
// ::v-deep .el-tag.el-tag--info:nth-child(1) .el-select__tags-text {
//   width: calc(100% - 20px);
//   float: left;
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   overflow: hidden;
// }
/*下拉选择框-多选-内容过长-用...代替    end    */

.checkBoxs {
  height: 490px;
  width: 96%;
  padding: 15px 10px 0 15px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 6px;
  .checkboxRow {
    display: block;
    height: 30px;
    line-height: 30px;
  }
}
.line-row {
  display: inline-block;
  line-height: 32px;
  margin-right: 10px;
  color: #ccc;
  text-align: center;
}

::v-deep .caret-wrapper {
  display: none !important;
}

.paixuBlue {
  color: #0094ff;
}
</style>
